import React from 'react';
import { RotateCcw, AlertCircle, CheckCircle, XCircle, Phone, Camera } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './PolicyPage.css';

const ReturnPolicyPage = () => {
  return (
    <>
      <Navbar />
      <div className="policy-page">

        <section className="policy-hero">
          <div className="container">
            <div className="policy-hero-badge"><RotateCcw size={14} /> Return Policy</div>
            <h1 className="policy-hero-title">Returns & <span>Replacements</span></h1>
            <p className="policy-hero-sub">We stand behind every product we sell. Here's how we handle issues with your order.</p>
          </div>
        </section>

        <section className="policy-body">
          <div className="container">
            <div className="policy-highlights">
              <div className="policy-highlight-card">
                <div className="policy-highlight-icon green"><CheckCircle size={24} /></div>
                <h3>Quality Guarantee</h3>
                <p>We replace spoiled products</p>
              </div>
              <div className="policy-highlight-card">
                <div className="policy-highlight-icon red"><XCircle size={24} /></div>
                <h3>No Cancellations</h3>
                <p>Once confirmed, orders are final</p>
              </div>
              <div className="policy-highlight-card">
                <div className="policy-highlight-icon"><Camera size={24} /></div>
                <h3>Photo Required</h3>
                <p>Send photos to claim replacement</p>
              </div>
              <div className="policy-highlight-card">
                <div className="policy-highlight-icon"><Phone size={24} /></div>
                <h3>Quick Response</h3>
                <p>Within 30 days resolution</p>
              </div>
            </div>

            <div className="policy-content">
              <div className="policy-section">
                <h2><AlertCircle size={20} /> Cancellation Policy</h2>
                <p>Once an order is confirmed and payment is received, <strong>no cancellations are accepted</strong>. Consequently, no refund will be issued for change-of-mind cancellations.</p>
                <p>We strongly recommend reviewing your cart carefully before completing your purchase.</p>
              </div>

              <div className="policy-section">
                <h2><CheckCircle size={20} /> When We Replace Products</h2>
                <p>We will replace your product free of charge if:</p>
                <ul>
                  <li>The product has perished and is in a condition unsuitable for consumption</li>
                  <li>The product is clearly different from what was ordered</li>
                  <li>The product was damaged during delivery</li>
                </ul>
                <div className="policy-notice">
                  <AlertCircle size={16} />
                  <p>You must report the issue within <strong>2 hours</strong> of receiving your order and provide photographic evidence.</p>
                </div>
              </div>

              <div className="policy-section">
                <h2><Camera size={20} /> How to Request a Replacement</h2>
                <p>Follow these steps to request a replacement:</p>
                <div className="policy-steps">
                  <div className="policy-step">
                    <div className="policy-step-num">1</div>
                    <div>
                      <h4>Take Photos</h4>
                      <p>Photograph the product clearly, showing the issue</p>
                    </div>
                  </div>
                  <div className="policy-step">
                    <div className="policy-step-num">2</div>
                    <div>
                      <h4>Contact Us</h4>
                      <p>Email sales@auroragh.com or call 0550866710 within 2 hours</p>
                    </div>
                  </div>
                  <div className="policy-step">
                    <div className="policy-step-num">3</div>
                    <div>
                      <h4>Provide Details</h4>
                      <p>Include your order number, waybill (AWB), reason, and photos</p>
                    </div>
                  </div>
                  <div className="policy-step">
                    <div className="policy-step-num">4</div>
                    <div>
                      <h4>Await Resolution</h4>
                      <p>We resolve all complaints within 30 calendar days</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="policy-section">
                <h2><Phone size={20} /> Contact for Returns</h2>
                <div className="policy-contact-grid">
                  <a href="mailto:sales@auroragh.com" className="policy-contact-item">
                    <strong>Email</strong>
                    <span>sales@auroragh.com</span>
                  </a>
                  <a href="tel:0550866710" className="policy-contact-item">
                    <strong>Phone</strong>
                    <span>0550866710</span>
                  </a>
                </div>
                <p className="policy-hours">Available Monday – Friday, 09:00 – 17:00 GMT</p>
              </div>
            </div>
          </div>
        </section>

      </div>
      <Footer />
    </>
  );
};

export default ReturnPolicyPage;